var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgXGray300(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7987_72129)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.99993 11.1788L14.7141 15.8929C14.8713 16.0447 15.0818 16.1287 15.3003 16.1268C15.5188 16.1249 15.7278 16.0373 15.8823 15.8828C16.0368 15.7283 16.1244 15.5193 16.1263 15.3008C16.1282 15.0823 16.0442 14.8718 15.8924 14.7146L11.1783 10.0004L15.8924 5.28628C16.0442 5.12911 16.1282 4.91861 16.1263 4.70012C16.1244 4.48162 16.0368 4.27261 15.8823 4.1181C15.7278 3.96359 15.5188 3.87595 15.3003 3.87405C15.0818 3.87216 14.8713 3.95615 14.7141 4.10795L9.99993 8.82212L5.28577 4.10795C5.12789 3.9599 4.91861 3.87909 4.70221 3.8826C4.48581 3.88612 4.27926 3.97368 4.12628 4.12678C3.97329 4.27987 3.88587 4.48648 3.88251 4.70288C3.87915 4.91929 3.96011 5.12851 4.10827 5.28628L8.8216 10.0004L4.10743 14.7146C4.02784 14.7915 3.96436 14.8834 3.92068 14.9851C3.87701 15.0868 3.85402 15.1961 3.85306 15.3068C3.8521 15.4174 3.87318 15.5272 3.91508 15.6296C3.95698 15.732 4.01886 15.825 4.0971 15.9033C4.17535 15.9815 4.26839 16.0434 4.37081 16.0853C4.47322 16.1272 4.58295 16.1483 4.6936 16.1473C4.80425 16.1464 4.9136 16.1234 5.01527 16.0797C5.11694 16.036 5.2089 15.9725 5.28577 15.8929L9.99993 11.1788Z",
    fill: "#DCDCDC"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7987_72129"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXGray300);
export default __webpack_public_path__ + "static/media/x_gray300.4f1abde1068289434c8c4a9d1074c544.svg";
export { ForwardRef as ReactComponent };